import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=370503d6"
import script from "./ConversationMessage.vue?vue&type=script&lang=js"
export * from "./ConversationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports